import { Component, EventEmitter, Injectable, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentModel, DocumentRoleModel, RoleModel, ServiceVerticalModel } from '../document-management/document-management.model';
import { MasterDataService } from '../../services/master-data.service';
import { CommonMessageService } from '../../services/common-message.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-create-folder',
  templateUrl: './create-folder.component.html',
  styleUrls: ['./create-folder.component.css']
})

export class CreateFolderComponent implements OnInit {
  @ViewChild('content') private content;
  @Input() folderDetail;
  @Input() hideSaveButtonOnEdit;
  @Output() modalChanged = new EventEmitter();

  documentModel: DocumentModel;
  hideSaveButton = false;
  roleList = [];
  selectedRole;
  selectedServiceVertical;

  constructor(private modalService: NgbModal,
    private masterDataService: MasterDataService,
    private commonMessageService: CommonMessageService,
    private router: Router) { }

  ngOnInit(): void {
    this.loadRole();
    this.loadServiceVertical();
    this.selectedRole = "";
    this.hideSaveButton = this.hideSaveButtonOnEdit;
  }

  ngAfterViewInit() {
    console.log('createfoilder this.folderDetail', this.folderDetail)
    setTimeout(() => {
      if (this.folderDetail != null || this.folderDetail != undefined) {
        this.documentModel = { ...this.folderDetail };
        this.openModal();
      } else {
        this.documentModel = new DocumentModel();
        console.log('content', this.content);
        this.openModal();
      }
    }, 1000)
  }

  loadRole() {
    this.masterDataService.getRoles().subscribe((resp: any) => {
      this.roleList = resp;
      console.log('rolelist', this.roleList);
    });
  }

  serviceVerticalList;
  loadServiceVertical() {
    this.masterDataService.getServiceVerticalList().subscribe((resp: any) => {
      this.serviceVerticalList = resp;
    });
  }

  // afterRoleSelect() {
  //   var documentRole = new DocumentRoleModel();
  //   var role = new RoleModel()
  //   role.name = this.selectedRole.name;
  //   role.id = this.selectedRole.id;
  //   documentRole.role = role
  //   this.documentModel.access.push(documentRole);
  //   console.log("documentModel", this.documentModel)
  // }

   onRoleChange() {
    // Clear service vertical whenever role changes
    this.selectedServiceVertical = null;
  
    // Remove existing entries for this role
    // this.documentModel.access = this.documentModel.access.filter(
    //   a => a.role?.id !== this.selectedRole?.id
    // );
  
    // Article → add immediately
    if (this.selectedRole?.name === 'Article') {
      const documentRole = new DocumentRoleModel();
  
      const role = new RoleModel();
      role.id = this.selectedRole.id;
      role.name = this.selectedRole.name;
  
      documentRole.role = role;
      documentRole.serviceVertical = null;
  
      this.documentModel.access.push(documentRole);
    }
  
    console.log('documentModel', this.documentModel);
  }
  
  onServiceVerticalChange() {
    // Non-Article → wait until service vertical is selected
    if (!this.selectedRole || this.selectedRole.name === 'Article') {
      return;
    }
  
    if (!this.selectedServiceVertical) {
      return;
    }
  
    // Remove existing entry for same role
    // this.documentModel.access = this.documentModel.access.filter(
    //   a => a.role?.id !== this.selectedRole.id
    // );

    this.documentModel.access = this.documentModel.access.filter(
  a => !(a.role?.id === this.selectedRole.id && a.serviceVertical?.id === this.selectedServiceVertical.id)
);
  
    const documentRole = new DocumentRoleModel();
  
    const role = new RoleModel();
    role.id = this.selectedRole.id;
    role.name = this.selectedRole.name;
  
    const serviceVertical = new ServiceVerticalModel();
    serviceVertical.id = this.selectedServiceVertical.id;
    serviceVertical.name = this.selectedServiceVertical.name;
  
    documentRole.role = role;
    documentRole.serviceVertical = serviceVertical;
  
    this.documentModel.access.push(documentRole);
    console.log('documentModel', this.documentModel);
  }

  deleteRoleRow(index) {
    this.documentModel.access.splice(index, 1);
  }

  openModal() {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'animate__animated animate__slideInUp animate__faster',
      backdrop: 'static',
      keyboard: false,
    };
    this.modalService.open(this.content, ngbModalOptions).result.then(
      (result) => {
        // this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  closeModel() {
    this.documentModel = new DocumentModel();
    this.modalService.dismissAll();
    this.selectedRole = "";
    this.modalChanged.emit({ showOpenModal: false });
  }

  onSaveClick() {
    if (this.documentModel.name == "") {
      this.commonMessageService.swalAlertWithoutIcon('', "Please Enter Folder Name");
      return;
    }
    console.log('root folder', JSON.stringify(this.documentModel));
    this.masterDataService.addFolder(this.documentModel).subscribe((resp: any) => {
      console.log('post response', resp);
      this.closeModel();
      this.commonMessageService.saveMessage();
    });
  }

  onUpdateClick() {
    console.log('edit folder', JSON.stringify(this.documentModel));
    this.folderDetail.name = this.documentModel.name;
    this.masterDataService.updateFolder(this.documentModel).subscribe((resp: any) => {
      this.closeModel();
      this.commonMessageService.updateMessage();
    });
  }

}
